import type { CabinClass } from '../types';

const CABIN_CLASSES: Record<string, CabinClass> = {
  ECONOMY: 'E',
  BUSINESS: 'B',
};

const DEFAULT_CABIN_CLASS = CABIN_CLASSES.ECONOMY;

const DEFAULT_PASSENGERS_STATE = {
  adt: 1,
  chd: 0,
  inf: 0,
  yth: 1,
};

export const passengersConfig = {
  DEFAULT_CABIN_CLASS,
  DEFAULT_PASSENGERS_STATE,
  CABIN_CLASSES,
};
